


























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Tab} from '../types/tab';
import WeirdCounter from './WeirdCounter.vue';
import BigButton from './input/BigButton.vue';
import {RawLocation} from 'vue-router';

@Component({
  name: 'TabFooter',
  components: {
    WeirdCounter,
    BigButton,
  },
})
export default class Footer extends Vue {

  @Prop() tab!: Tab;
  @Prop() name!: string;
  @Prop() price!: string;
  @Prop() period!: string;
  @Prop() quantity!: string;
  @Prop({default: true}) buttonEnabled!: boolean;
  @Prop({default: false}) buttonDisplayStop: boolean | undefined;

  route(location: RawLocation): void {
    this.$router.push(location);
  }

  handleButtonClicked() {
    this.$emit('buttonClicked');
  }
}
